








import { Prop, Component,  Vue } from 'vue-property-decorator'
import { DoughnutChart } from 'vue-chart-3'
import { Chart, ChartData, ChartOptions, DoughnutController, ArcElement, Tooltip } from 'chart.js'
Chart.register(DoughnutController, ArcElement, Tooltip)

@Component({
    components: {
        DoughnutChart,
    },
})
export default class ChartDoughnut extends Vue {
    @Prop({ default: () => [] }) readonly data!: ChartData
    @Prop({ default: () => [] }) readonly options!: ChartOptions<'doughnut'>
    @Prop({ default: () => [] }) readonly plugins!: object[]

    get chartOptions(): ChartOptions<'doughnut'> {
        return Object.assign({
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                easing: 'easeOutExpo',
            },
            plugins: {
                legend: {
                    position: 'right',
                },
                tooltip: {
                    backgroundColor: '#1e2a46',
                    titleFontSize: 18,
                    titleFontStyle: 'bold',
                    bodyFontSize: 18,
                    bodySpacing: 9,
                    xPadding: 9,
                    yPadding: 9,
                    caretSize: 16,
                },
            },
        }, this.options)
    }
}
